// Modern MUI v6 Styles using sx prop patterns
// This file exports reusable style objects that can be used with the sx prop

import imm from "../../fondb.jpg";

// Export a function that returns styles based on the current theme
export const getStyles = (theme) => ({
    root: {
        width: "100%"
    },

    paperUno: {
        marginTop: 1,
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
        boxShadow: "none",
        backgroundColor: 'transparent'
    },

    Not: {
        width: "100%",
        flexDirection: "row",
    },

    paper: {
        marginTop: 4, // Reduced from 8
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        padding: { xs: 2, sm: 4 }, // Responsive padding
        backgroundColor: theme.palette.background.paper,
        borderRadius: '16px',
        boxShadow: '0px 4px 20px rgba(0,0,0,0.05)',
        border: `1px solid ${theme.palette.divider}`,
    },

    form: {
        width: "100%",
        marginTop: 2,
        paddingLeft: 0,
        paddingRight: 0,
    },

    submit: {
        marginTop: 3,
        fontSize: '1rem',
        padding: '12px 0',
        borderRadius: '8px',
        fontWeight: 600,
        boxShadow: 'none',
        textTransform: 'none',
    },

    icon: {
        fontSize: 100
    },

    marTo: {
        fontSize: 30,
    },

    LogoIcon: {
        fontSize: '15rem',
        width: "100%",
        padding: 20,
        color: theme.palette.primary.contrastText,
        backgroundPosition: "center",
        backgroundSize: "cover",
        filter: "drop-shadow(0px 4px 4px rgba(0,0,0,0.25))",
    },

    logoU: {
        width: "100%",
    },

    logoPe: {
        width: 'auto',
        maxWidth: '100%',
        height: 80,
        marginBottom: 20,
    },

    mentex: {
        paddingLeft: 15,
        color: theme.palette.text.primary,
        fontWeight: 500
    },

    menico: {
        marginLeft: 0,
        fontSize: 24,
    },

    menuActive: {
        "&.active": {
            backgroundColor: theme.palette.primary.lighter,
            color: theme.palette.primary.main,
            borderRight: `3px solid ${theme.palette.primary.main}`,
            borderRadius: '0 8px 8px 0', // Rounded right side
        },
    },

    marginall: {
        padding: '10px 16px',
        color: theme.palette.text.secondary,
        borderRadius: '8px',
        marginBottom: '4px',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: theme.palette.background.neutral,
            color: theme.palette.text.primary
        },
    },

    avatarC: {
        height: 40,
        width: 40,
    },

    poster: {
        width: 100,
        height: 75,
        borderRadius: '8px',
        objectFit: 'cover'
    },

    LePri: {
        fontSize: 20,
        fontWeight: 700,
        color: theme.palette.primary.main,
    },

    rootCar: {
        maxWidth: "100%",
        marginBottom: 2,
        borderRadius: 16,
        border: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
        boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1)',
            borderColor: theme.palette.primary.main, // Highlight on hover
        }
    },

    fondoLogin: {
        backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
        backgroundPosition: "center",
        textAlign: 'center',
        backgroundSize: "cover",
        padding: { xs: 2, md: 5 }, // Less padding on mobile
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        color: theme.palette.primary.contrastText,
    },

    avatarProducto: {
        width: 80,
        height: 80,
        backgroundColor: theme.palette.background.neutral,
        borderRadius: '16px', // Modern squircle
        color: theme.palette.primary.main
    },

    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
    },

    avatarMeasure: {
        width: 120,
        height: 120,
        backgroundColor: theme.palette.background.neutral,
        borderRadius: '50%',
        border: `4px solid ${theme.palette.background.paper}`,
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
});

export default getStyles;